import { Paginator, PaginatorProps } from 'primereact/paginator'

import Pagination from '../../models/Pagination'
import { Row } from '../common/pure/FlexContainer'
import t from '../../tools/t'

interface PaginationProps<T> extends PaginatorProps {
    data: Pagination<T>
}

export default function TablePagination<T>({ data, ...props }: PaginationProps<T>) {
    if (!(data && data.totalCount > 0)) return
    return (
        <Row className="table-pagination" alignment="center">
            {data.totalCount > 1 && (
                <div className="table-pagination__total">
                    {t('pagination_x_results_label', data.totalCount.toString())}
                </div>
            )}
            {data.hasMultiplePages && (
                <Paginator
                    {...props}
                    className="table-pagination__pagination"
                    first={data.first}
                    rows={data.pageSize}
                    totalRecords={data.totalCount}
                    // NOTE: Primereact Paginator suggests holding first and page as a state,
                    //  but because we receive this data from the backend,
                    //  we cannot allow the paginator component to tell us the page we are showing.
                    onPageChange={(e) => data.page(e.page)}
                />
            )}
        </Row>
    )
}
